<main>
  <div class="deviceName">
    <span>{{data.device.deviceName}}</span>
  </div>
  <div class="subTitle">
    <span>Historique</span>
  </div>
  <div >
    <div class="header">
      <span>Jour</span>
      <span>Heure</span>
      <span>Etat</span>
    </div>
    <div class="histContainer">
      <div class="histElem" *ngFor="let elem of history">

        <span>{{elem.timestamp | date:'shortDate'}}</span>
        <span>{{elem.timestamp | date:'shortTime'}}</span>
        <div class="status">
          <div class="statusSymbol" [ngClass]="{'online': elem.status == 'online', 'offline': elem.status == 'offline'}">

          </div>
          <span class="statusText">{{elem.status}}</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <button mat-raised-button color="accent" mat-dialog-close>Valider</button>
    </div>
  </div>

</main>
